// import { yupResolver } from "@hookform/resolvers/yup"
import { faGift } from "@jewlr/pro-light-svg-icons/faGift"
import { faMinus } from "@jewlr/pro-regular-svg-icons/faMinus"
import { faPlus } from "@jewlr/pro-regular-svg-icons/faPlus"
import { faChevronDown } from "@jewlr/pro-solid-svg-icons/faChevronDown"
import { faChevronUp } from "@jewlr/pro-solid-svg-icons/faChevronUp"
// import { faTrash } from "@jewlr/pro-solid-svg-icons/faTrash"
import PropTypes from "prop-types"
import { useState } from "react"
// import { useCallback, useEffect, useState } from "react"
// import { useForm } from "react-hook-form"
// import { useDispatch, useSelector } from "react-redux"
// import * as Yup from "yup"

// import { setGiftWrapAndGreetingCard } from "areas/cart/store/actions"
import { getDATA } from "areas/landing/elements/landing-packaging"
import Button from "components/ui/button"
// import Checkbox from "components/ui/checkbox"
import Expand from "components/ui/expand"
import FontAwesomeIcon from "components/ui/font-awesome-icon"
import Image from "components/ui/image"
import Media from "components/ui/media"
import { jewlr_t, isTestMode } from "helpers/application"
import { getImgSrcSet } from "helpers/image"
// import { to_currency } from "helpers/number"

import GiftBundles from "./gift-bundles"
// import GiftWraps from "./gift-wraps"
// import GreetingCard from "./greeting-card"

// const schema = Yup.object().shape({
//   card: Yup.object().nullable(),
//   message: Yup.string().max(200, "Maximum 200 characters"),
//   wrap: Yup.object().nullable(),
// })

// const VIEW = {
//   ADD: "ADD",
//   EDIT: "EDIT",
// }

// const NewGiftOptions = ({ item }) => {
//   const dispatch = useDispatch()
//   const giftPackageOptions = item.gift_package_options
//   const greetingCardOptions = item.greeting_card_options

//   const addedCard = item.addons?.find(
//     (addon) => addon.addon_type === "GREETING_CARD"
//   )
//   const addedWrap = item.addons?.find(
//     (addon) => addon.addon_type === "PACKAGING" && addon.id !== "NONE"
//   )

//   const [showGiftOption, setShowGiftOption] = useState(
//     !!(addedCard || addedWrap)
//   )
//   const [view, setView] = useState(
//     addedCard || addedWrap ? VIEW.EDIT : VIEW.ADD
//   )
//   const [deleting, setDeleting] = useState(false)

//   const {
//     control,
//     formState: { errors, isSubmitting },
//     handleSubmit,
//     reset,
//     setError,
//     setValue,
//     watch,
//   } = useForm({
//     defaultValues: {
//       card: null,
//       message: "",
//       wrap: null,
//     },
//     mode: "onBlur",
//     resolver: yupResolver(schema),
//   })

//   const selectedCard = watch("card")
//   const selectedGiftWrap = watch("wrap")

//   const submitUpdate = useCallback(
//     async (data) => {
//       try {
//         const card =
//           data && data.card ? { ...data.card, message: data.message } : null
//         const wrap = data && data.wrap ? data.wrap : null

//         if (!isTestMode) {
//           if (card) {
//             dataLayer.push({
//               event: "added-gift-packaging-to-cart",
//               giftPackaging: card.addon_code,
//               giftType: "GREETING_CARD",
//             })
//           }
//           if (wrap) {
//             dataLayer.push({
//               event: "added-gift-packaging-to-cart",
//               giftPackaging: wrap.id,
//               giftType: "PACKAGING",
//             })
//           }
//         }

//         await new Promise((res, rej) => {
//           dispatch(
//             setGiftWrapAndGreetingCard(item.id, wrap, card, "cart", {
//               onError: (err) => rej(err),
//               onSuccess: () => res(),
//             })
//           )
//         })
//       } catch (err) {
//         setError("root.error", { message: err })
//       } finally {
//         setDeleting(false)
//       }
//     },
//     [giftPackageOptions, setDeleting]
//   )

//   const onSubmit = useCallback(
//     async (data) => {
//       setView(VIEW.EDIT)
//       await submitUpdate(data)
//     },
//     [submitUpdate, setView]
//   )

//   const onClear = useCallback(async () => {
//     reset()
//     setView(VIEW.ADD)
//     if (addedCard || addedWrap) {
//       setDeleting(true)
//       await submitUpdate()
//     }
//   }, [addedCard, addedWrap, submitUpdate, reset, setView])

//   const onEdit = () => {
//     setShowGiftOption(true)
//     setView(VIEW.ADD)
//   }

//   useEffect(() => {
//     setValue("card", addedCard)
//     setValue("wrap", addedWrap)
//     setValue(
//       "message",
//       addedCard?.custom_properties?.greeting_card_properties?.message || ""
//     )
//   }, [addedCard, addedWrap])

//   return view === VIEW.EDIT ? (
//     <div className="mt-10 py-16">
//       <div className="mb-10 flex items-center gap-8">
//         <FontAwesomeIcon className="text-primary text-20" icon={faGift} />
//         <h2
//           className="text-primary grow-1 text-16 tracking-tigher leading-20 font-bold"
//           id={`cart-line-item-selected-gift-options-heading-${item.id}`}
//         >
//           Gifting
//         </h2>
//         <Button
//           aria-label="Remove selected gifting options"
//           disabled={deleting}
//           onClick={onClear}
//         >
//           <FontAwesomeIcon className="text-primary text-12" icon={faTrash} />
//         </Button>
//       </div>
//       <ul
//         aria-labelledby={`cart-line-item-selected-gift-options-heading-${item.id}`}
//         className="flex list-none flex-col gap-12"
//       >
//         {[addedCard, addedWrap].filter(Boolean).map((addon) => (
//           <li
//             className="my-4 flex items-center justify-between gap-12"
//             key={`gift-option-${item.id}-${addon.addon_code}`}
//           >
//             <Image
//               alt={`Preview of ${addon.title}`}
//               className="w-50"
//               height="140"
//               src={addon.image_url}
//               width="140"
//             />
//             <div className="grow-1">
//               <p className="text-14 tracking-tigher leading-20 font-semibold">
//                 {addon.title}
//               </p>
//               <p className="text-13 tracking-tigher leading-16">
//                 {to_currency(addon.price, { precision: 2 })}
//               </p>
//             </div>
//             <Button
//               aria-label={`Edit ${addon.title}`}
//               className="text-14 font-medium"
//               onClick={onEdit}
//               text
//               variant="secondary"
//             >
//               Edit
//             </Button>
//           </li>
//         ))}
//       </ul>
//     </div>
//   ) : (
//     <div className="bg-grey-4 mt-10 px-12 py-16">
//       <Checkbox
//         aria-checked={showGiftOption}
//         aria-controls={`cart-line-item-gift-options-accordion-content-${item.id}`}
//         aria-labelledby={`cart-line-item-gift-options-heading-${item.id}`}
//         checkboxClassName="border-primary text-white aria-checked:bg-primary"
//         checked={showGiftOption}
//         className="w-full"
//         data-cy={`cart-line-item-packaging-checkbox-${item.style_code}`}
//         id={`cart-line-item-gift-options-accordion-heading-${item.id}`}
//         onChange={() => {
//           if (!isTestMode) {
//             dataLayer.push({ event: "expand-cart-line-item-gift-option" })
//           }
//           if (showGiftOption) {
//             onClear()
//           }
//           setShowGiftOption(!showGiftOption)
//         }}
//         role="switch"
//       >
//         <h2
//           className="text-primary text-14 mobile:text-16 font-bold"
//           id={`cart-line-item-gift-options-heading-${item.id}`}
//         >
//           Make this a gift
//         </h2>
//       </Checkbox>
//       <Expand
//         aria-labelledby={`cart-line-item-gift-options-accordion-heading-${item.id}`}
//         className="pt-10"
//         id={`cart-line-item-gift-options-accordion-content-${item.id}`}
//         role="region"
//         show={showGiftOption}
//       >
//         <form onSubmit={handleSubmit(onSubmit)}>
//           {greetingCardOptions?.length > 0 && (
//             <GreetingCard
//               control={control}
//               item={item}
//               selectedCard={selectedCard}
//               setValue={setValue}
//             />
//           )}
//           {giftPackageOptions?.length > 0 && (
//             <GiftWraps
//               item={item}
//               selectedGiftWrap={selectedGiftWrap}
//               setValue={setValue}
//             />
//           )}
//           {errors?.root?.error && (
//             <p className="text-error text-13 py-8">
//               {errors.root.error.message}
//             </p>
//           )}
//           <Button
//             className="desktop:max-w-(--desktop-width) mt-8 w-full"
//             data-cy="cart-line-item-gift-options-add-btn"
//             disabled={isSubmitting || !(selectedCard || selectedGiftWrap)}
//             loading={isSubmitting}
//             style={{ "--desktop-width": "268px" }}
//             type="submit"
//             variant="primary"
//           >
//             {addedCard || addedWrap ? "Update" : "Add"}
//           </Button>
//         </form>
//       </Expand>
//     </div>
//   )
// }

// NewGiftOptions.propTypes = {
//   item: PropTypes.object,
// }

const GiftOptions = ({ item }) => {
  const hasGiftBundleOptions = item.gift_bundle_options?.length > 0
  const hasSelectedOption = item.addons?.some(
    ({ addon_type }) => addon_type === "GIFT_BUNDLE"
  )
  const [showGift, toggleShowGift] = useState(hasSelectedOption)

  const { image } = getDATA()
  const imgSrcSet = getImgSrcSet(image.mobile, image.mobile_width, {
    sizes: [110, 130, 220, 260],
  })

  if (!hasGiftBundleOptions) return null

  // return cartWarrantyExp === 1 ? (
  //   <NewGiftOptions item={item} />
  // ) : (
  return (
    <div className="tablet:px-4 border-t-grey-10 border-t py-14">
      <h3>
        <Button
          aria-controls={`cart-line-item-gift-option-content-${item.id}`}
          aria-expanded={showGift}
          aria-label={`Add a ${jewlr_t("terms.personalized")} gift packaging`}
          className="block w-full"
          id={`cart-line-item-gift-option-heading-${item.id}`}
          onClick={() => {
            if (!isTestMode) {
              dataLayer.push({ event: "expand-cart-line-item-gift-option" })
            }
            toggleShowGift(!showGift)
          }}
        >
          <div
            className="text-link flex w-full items-center justify-between"
            data-cy={`cart-line-item-packaging-checkbox-${item.style_code}`}
          >
            <div className="flex items-center">
              <FontAwesomeIcon className="mr-8" icon={faGift} />
              <p className="text-primary text-16 leading-20 tracking-tigher mr-auto font-medium">
                Is This A Gift?
              </p>
            </div>
            <Media greaterThanOrEqual="tablet">
              <Expand show={showGift}>
                <FontAwesomeIcon
                  className="text-primary text-9"
                  icon={faChevronUp}
                />
              </Expand>
            </Media>
            <Media lessThan="tablet">
              <div className="flex items-center">
                <FontAwesomeIcon
                  className="text-14 text-primary"
                  icon={showGift ? faMinus : faPlus}
                />
              </div>
            </Media>
          </div>
          <Expand show={!showGift}>
            <div className="tablet:mb-0 tablet:mt-10 my-16 flex items-center justify-between">
              <div className="flex items-center">
                <Image
                  alt=""
                  className="w-(--base-width) tablet:w-(--tablet-width) mr-8"
                  height={image.mobile_height}
                  sizes="(min-width: 768px) 130px, 110px"
                  srcSet={imgSrcSet}
                  style={{
                    "--base-width": "110px",
                    "--tablet-width": "130px",
                  }}
                  width={image.mobile_width}
                />
                <div className="text-left">
                  <p className="text-14 tablet:text-16 tracking-tigher leading-20 font-medium">
                    Add a {jewlr_t("terms.personalized")} gift packaging
                  </p>
                  <p className="text-13 leading-14 tracking-tigher font-light">
                    Choose your packaging add-ons for the ultimate gifting
                    experience.
                  </p>
                </div>
              </div>
              <Media greaterThanOrEqual="tablet">
                <div className="flex items-center text-right">
                  <p className="text-primary text-12 leading-14 tracking-tigher ml-auto mr-6 font-medium">
                    Add Gift Packaging
                  </p>
                  <FontAwesomeIcon
                    className="text-primary text-9"
                    icon={faChevronDown}
                  />
                </div>
              </Media>
            </div>
          </Expand>
        </Button>
      </h3>
      <Expand
        aria-labelledby={`cart-line-item-gift-option-heading-${item.id}`}
        className="pt-24"
        id={`cart-line-item-gift-option-content-${item.id}`}
        show={showGift}
      >
        {hasGiftBundleOptions && <GiftBundles item={item} source="cart" />}
      </Expand>
    </div>
  )
}

GiftOptions.propTypes = {
  item: PropTypes.object,
}

export default GiftOptions
